import styled from '@emotion/styled'

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 490px;
  width: 100%;
`
